import { render, staticRenderFns } from "./ChooseSiteNameModal.vue?vue&type=template&id=0b99a686&scoped=true"
import script from "./ChooseSiteNameModal.vue?vue&type=script&lang=js"
export * from "./ChooseSiteNameModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseSiteNameModal.vue?vue&type=style&index=0&id=0b99a686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b99a686",
  null
  
)

export default component.exports